class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('Cart-LineItemStatus');
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log('EVENT', event);
      console.log('EVENT_SOURCE', event.source);

      if (event.source === 'cart-items') {
        console.log('EVENT_CART', event.cartData);
        const cart = event.cartData;
        // If Flyer in cart, check if cullote -- If not remove Flyer
        if (cart.items_removed.length > 0) {
          console.log('ITEM_REMOVED', cart.items_removed[0].product_type);
          //if(cart.items_removed[0].product_type === 'Culotte menstruelle')
          let guideInCart = cart.items.find((item) => item.product_type == 'Guide');

          if (guideInCart) {
            console.log('guideInCart', guideInCart);
            console.log('guideInCart INDEX', guideInCart.id);
            let culotteInCart = cart.items.filter((item) => item.product_type == 'Culotte menstruelle');
            console.log('culotteInCart', culotteInCart);
            if (culotteInCart.length < 1) {
              console.log('no culotteInCart', culotteInCart);
              let index = cart.items.findIndex((item) => item.id === guideInCart.id);
              console.log('INDEX', index);
              this.updateQuantity(index + 1, 0);
            }
          }
        }
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Item-Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    console.log('CART_UPDATE', this.dataset.id);
    // When add to cart
    let cartSection = this.dataset.id;
    console.log('cartSection', cartSection);

    document.getElementById('Cart').classList.remove('is-empty');

    fetch(`${routes.cart_url}?section_id=${cartSection}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-items', '.cart__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        console.log(response);
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        console.log('PARSED_STATE', parsedState);
        console.log('PARSED_STATE_ERRORS', parsedState.errors);

        const quantityElement = document.getElementById(`Item-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartWrapper = document.querySelector('#Cart');
        const cartFooter = document.querySelector('#CartFooter');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartWrapper) cartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          if (!section.id) return;
          const elementToReplace =
            document.getElementById(section.section).querySelector(section.selector) ||
            document.getElementById(section.id);
          if (!elementToReplace) return;
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';

        console.log(
          'CONDITIONS',
          items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)
        );
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          console.log('typeof updatedValue', typeof updatedValue);
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        console.log('message', message);
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          console.log('CASE_1');
          cartWrapper
            ? trapFocus(cartWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartWrapper) {
          console.log('CASE_2');
          trapFocus(cartWrapper.querySelector('.cart__inner-empty'), cartWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartWrapper) {
          console.log('CASE_3', cartWrapper);
          console.log('CASE_3', document.querySelector('.cart-item__name'));
          trapFocus(cartWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((error) => {
        console.log('cartError', error);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    console.log('updateLiveRegions', line);
    const lineItemError = document.getElementById(`Cart-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('Cart-liveRegionText');
    console.log('cartStatus', cartStatus);
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionsToRender() {
    return [
      {
        section: 'CartItems',
        id: document.querySelector('#CartItems').dataset.id,
        selector: '.js-cart__items',
      },
      {
        section: 'CartFooter',
        id: document.querySelector('#CartFooter').dataset.id,
        selector: '.js-cart__footer',
      },
      {
        section: 'CartUpsell',
        id: document.querySelector('#CartUpsell')?.dataset.id,
        selector: '.js-cart__upsell',
      },
      {
        section: 'cart-icon-bubble',
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class McpRadioSelect extends HTMLElement {
  constructor() {
    super();

    this.cartItems = document.querySelector('cart-items');

    this.cartSubscriptionsContainer = document.getElementById('CartSubsriptionItems');
    //this.currentPlan = "";
    this.currentPlan = this.querySelector('input[name="selling-plans"]:checked').value;

    this.selector = this.querySelector('.js-selector');
    this.options = this.querySelectorAll('.option');
    this.selectLabel = this.querySelector('.js-select-label');

    this.selectedVariant = '';

    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.addEventListener('mousedown', function (event) {
      if (
        !event.target.parentElement.classList.contains('js-dropdownSelect') &&
        !event.target.parentElement.classList.contains('js-selectGroup')
      ) {
        document.querySelectorAll('.js-selector').forEach((selector) => selector.classList.add('dropdown-is-closed'));
      }
    });
  }

  handleClick(event) {
    event.preventDefault();
    if (event.target === this.selector) {
      this.toggleIsClosed();
    }

    if (event.target.classList.contains('select-item')) {
      this.currentVariantLabel = event.target.getAttribute('for');
      this.currentVariant = event.target.getAttribute('variantId');

      const allSelectLabel = [...document.querySelectorAll('.js-select-label')];
      allSelectLabel.forEach((selectLabel) => {
        selectLabel.innerHTML = event.target.innerHTML;
      });
      document.getElementById(`${this.currentVariantLabel}`).checked = true;

      this.toggleIsClosed();
      let selectedPlan;
      for (const option of this.options) {
        if (option.checked) {
          selectedPlan = option.value;
          break;
        }
      }

      if (selectedPlan === this.currentPlan) return;

      console.log('CHANGE PLAN');
      this.updateItemSubscription(selectedPlan);
    }
  }

  toggleIsClosed() {
    this.selector.classList.toggle('dropdown-is-closed');
  }

  async updateItemSubscription(plan) {
    let abos = this.cartSubscriptionsContainer.querySelectorAll('.cart-item');
    console.log('ABOS', abos);

    for (let i = 0; i < abos.length; i++) {
      let planArray = JSON.parse(abos[i].querySelector('[type="application/json"]').textContent);
      let newSellingPlanId = planArray.selling_plans.find((sellingPlan) => sellingPlan.name === plan).id;
      console.log('newSellingPlan', newSellingPlanId);

      const body = JSON.stringify({
        id: abos[i].dataset.key,
        quantity: parseInt(abos[i].dataset.qty),
        selling_plan: parseInt(newSellingPlanId),
      });

      await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body },
      })
        .then((response) => {
          return response.json();
        })
        .then((state) => {
          console.log('CHANGE', state);
          document.querySelector('#CartDrawer-Checkout').disabled = true;
          this.cartItems.enableLoading(abos[i].dataset.line, 'loading__spinner.selling-plan');
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    this.currentPlan = plan;
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'radio-select',
      currentPlanName: this.currentPlan,
    });
    console.log('currentPlan', this.currentPlan);
  }
}
customElements.define('mcp-radio-select', McpRadioSelect);

/*
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    console.log('CLOSE');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
*/
